import classNames from "classnames";
import React, { AnchorHTMLAttributes, ButtonHTMLAttributes, PropsWithChildren } from "react";

export type BreadcrumbsCustomProps = PropsWithChildren<{
  asElement: any;
  hrefAttribute?: string;
  ariaLabel: string;
}> &
  ButtonHTMLAttributes<HTMLButtonElement> &
  AnchorHTMLAttributes<HTMLAnchorElement>;

export function SVVBreadcrumbCustom({
  children,
  asElement,
  ariaLabel,
  className,
  hrefAttribute,
  ...rest
}: BreadcrumbsCustomProps) {
  const Element = asElement;
  return (
    <nav className="svv-breadcrumb" aria-label={ariaLabel}>
      <Element
        className={classNames("svv-breadcrumb__element", className)}
        {...(hrefAttribute && rest.href && { [hrefAttribute]: rest.href })}
        {...rest}
      >
        {children}
      </Element>
    </nav>
  );
}

SVVBreadcrumbCustom.displayName = "SVVBreadcrumbCustom";
